import { checkRegisterAvailabilityFetch } from '../../../api/checkRegisterAvailability';
import { State, StateContext } from '../base/state';
import { stateTypes } from '../constants';

export class Context extends StateContext {
  constructor(controller) {
    super({
      controller,
      InitialInstance: InitialState,
      eventType: stateTypes.registerAvailability,
    });
  }

  async isRegistrationAvailable(addressId) {
    this.transitionTo(new LoadingState());

    const result = await checkRegisterAvailabilityFetch({
      queryClient: this.controller.queryClient,
      params: { addressId },
    });

    if (result === 'Error' || typeof result !== 'boolean') {
      this.transitionTo(
        new ErrorState({
          refetch: () => this.isRegistrationAvailable(addressId),
        })
      );
      return false;
    }

    if (result === true) {
      this.transitionTo(new NotAvailableState());
      this.controller.api.invalidateRooms();
      return false;
    }

    this.transitionTo(new SuccessState());

    return true;
  }
}

export class InitialState extends State {
  constructor() {
    super({ status: 'idle' });
  }
}

export class LoadingState extends State {
  constructor() {
    super({ status: 'loading' });
  }
}

export class ErrorState extends State {
  constructor({ refetch }) {
    super({
      status: 'error',
      message: 'Ошибка при проверке доступности записи. Попробуйте еще раз',
      refetch,
    });
  }
}

export class NotAvailableState extends State {
  constructor() {
    super({
      status: 'notAvailable',
      message: 'Невозможно записаться на выбранное помещение',
    });
  }
}

export class SuccessState extends State {
  constructor() {
    super({ status: 'success' });
  }
}
